import React, { Component } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import Apps from "app/pages/apps"
import Entrance from "app/pages/entrance"
import Login from "app/pages/login/index"
import DownloadChrome from "app/pages/downloadChrome/DownloadChrome"

import { inject, observer } from "mobx-react"
import "app/Index.scss"
import "app/styles/sass/modal.scss"
import "app/styles/sass/base.scss"
import "app/styles/less/ant-theme-vars.less"

@inject("auth", "entrance") @observer
export default class Welcome extends Component {
  render () {
    const {match} = this.props
    return (
      <div className="login-back">
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/entrance`} />
          <Route path={`${match.url}/login`} component={Login} />
          <Route path={`${match.url}/download_chrome`} component={DownloadChrome} />
          <Route path={`${match.url}/apps`} component={Apps} />
          <Route path={`${match.url}/:app/entrance`} component={Entrance} />
          <Redirect from='*' to={`${match.url}/apps`} />
        </Switch>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Welcome.js